import { Button } from '@givebutter/primitives/button';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { faBookmark as faBookmarkSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CountBadge } from 'assets/js/pages/contacts/data-hygiene/CountBadge';

interface ToggleSaveForLaterButtonProps {
    savedForLater: boolean;
    toggleSavedForLater: () => void;
    count: number;
}

const ToggleSaveForLaterButton = ({
    savedForLater,
    toggleSavedForLater,
    count,
}: ToggleSaveForLaterButtonProps) => {
    return (
        <Button
            variant="outline"
            color="neutral"
            className="!px-3"
            onClick={() => {
                toggleSavedForLater();
            }}
        >
            {savedForLater ? (
                <FontAwesomeIcon icon={faBookmarkSolid} className={'text-green-600'} />
            ) : (
                <FontAwesomeIcon icon={faBookmark} className="" />
            )}
            <CountBadge
                className="min-w-0"
                count={count || null} /* Hides badge when 0 */
                size="sm"
            />
        </Button>
    );
};

export { ToggleSaveForLaterButton };
